import { actionBuilder } from '../../functions/redux';
import * as type from './types';

export const getProfile = actionBuilder(type.AUTHEN_GET_PROFILE_REQ);
export const login = actionBuilder(type.AUTHEN_LOGIN_REQ);
export const loginGoogle = actionBuilder(type.AUTHEN_LOGIN_GOOGLE_REQ);
export const logout = actionBuilder(type.AUTHEN_LOGOUT_REQ);
